import React, { useEffect, useState } from "react";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../../Layout/GRISidebar";
import styles from "../../../../styles/gri/general.module.css";
import InputField from "../../../../Components/Masters/InputField";
import { Box, Button } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { get, put } from "../../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import RadioButtons from "../../../../Components/Common/RadioButtons";
import ReviewBox from "../../../../Components/Common/ReviewBox";

import { currentYear } from "../../../../utils/generateYearRanges";

const GRI303_2 = ({ hide }) => {
  const questionData = [
    {
      fieldName: "operatingStandards",
      title:
        "i. How were standards for facilities operating in locations with no local discharge requirements determined?",
      type: "text",
      placeholder: "Enter Text",
      letter: "i.",
    },
    {
      fieldName: "internalWaterQualityStandards",
      title:
        "ii. Were any internally developed water quality standards or guidelines considered? If so, please describe.",
      type: "text",
      placeholder: "Enter Text",
      letter: "ii.",
    },
    {
      fieldName: "sectorSpecificStandards",
      title:
        "iii. Were any sector-specific standards considered? If yes, please specify.",
      type: "text",
      placeholder: "Enter Text",
      letter: "iii.",
    },
    {
      fieldName: "waterBodyProfileConsidered",
      title:
        "iv. Was the profile of the receiving water body considered when setting effluent discharge standards?",
      type: "text",
      placeholder: "Enter Text",
      letter: "iv.",
    },
  ];

  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [data, setData] = useState({});
  const [formData, setFormData] = useState({});
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [griReview, setGriReview] = React.useState(() => JSON.parse(localStorage.getItem("griReview")));

  React.useEffect(() => {
    const handleStorage = () => setGriReview(JSON.parse(localStorage.getItem("griReview")));
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);
  React.useEffect(() => {
    setGriReview(JSON.parse(localStorage.getItem("griReview")));
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(`/gri/get?Id=${id}&type=GRI300`);
      if (res?.data?.data?.year ? res?.data?.data?.year < currentYear -1 : false) setDisabled(true);
      const res1 = res?.data?.data?.GRI300?.waterManagement;
      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (data)
      setFormData({
        operatingStandards: data?.operatingStandards || "",
        internalWaterQualityStandards: data?.internalWaterQualityStandards || {
          status: true,
          remark: "",
        },
        sectorSpecificStandards: data?.sectorSpecificStandards || {
          status: true,
          remark: "",
        },
        waterBodyProfileConsidered: data?.waterBodyProfileConsidered || {
          status: true,
          remark: "",
        },
      });
  }, [data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));

    if (name === "operatingStandards") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: { ...prev?.[name], remark: value },
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (
      formData?.waterBodyProfileConsidered?.status &&
      formData?.waterBodyProfileConsidered?.remark === ""
    )
      newErrors["waterBodyProfileConsidered"] = "This field is Required";

    if (
      formData?.sectorSpecificStandards?.status &&
      formData?.sectorSpecificStandards?.remark === ""
    )
      newErrors["sectorSpecificStandards"] = "This field is Required";

    if (
      formData?.internalWaterQualityStandards?.status &&
      formData?.internalWaterQualityStandards?.remark === ""
    )
      newErrors["internalWaterQualityStandards"] = "This field is Required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      // Clear remarks for fields where the status is false
      const updatedFormData = Object.keys(formData).reduce((acc, key) => {
        if (
          typeof formData[key] === "object" &&
          formData[key]?.status === false
        ) {
          acc[key] = { ...formData[key], remark: "" }; // Clear remark
        } else {
          acc[key] = formData[key];
        }
        return acc;
      }, {});

      if (!validateForm()) return;

      let transformedData2 = {
        waterManagement: updatedFormData,
        type: "GRI300",
        submitted303_2: true,
      };

      try {
        const res = await put(`/gri/update?Id=${id}`, transformedData2);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/gri/gri300/303-3/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.response?.data?.message || "An error occurred",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/gri300/303-3/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
    <>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      {/* <Box sx={{ display: "flex" }}> */}
      {!hide && (
        <p className={styles.section_heading}>303 : Water & Effluents</p>
      )}
      <p
        className={styles.main_heading}
        style={{ marginBottom: hide ? "-1rem" : "0" }}
      >
        303-2 : Management of water discharge related impacts
      </p>
      {/* a */}
      <p className={styles.ques_heading}>
        a. Describe any minimum standards set for the quality of effluent
        discharge.
      </p>
      {questionData?.map((el) => (
        <Box sx={{ mt: hide ? "-2rem" : "2rem", ml: "1.2rem" }}>
          <p className={styles.ques_heading}>{el?.title}</p>
          {el?.fieldName !== "operatingStandards" && (
            <Box sx={{ mt: "-1.5rem" }}>
              <RadioButtons
                value={formData?.[el.fieldName]?.status || false}
                handleChange={(e) => {
                  const value = e.target.value === "true"; // Convert string to boolean
                  setFormData((prev) => ({
                    ...prev,
                    [el.fieldName]: {
                      ...prev?.[el.fieldName],
                      status: value,
                    },
                  }));
                  setErrors((prev) => ({
                    ...prev,
                    remark: "",
                  }));
                }}
                disabled={disabled}
              />
            </Box>
          )}
          {(el?.fieldName === "operatingStandards" ||
            formData?.[el.fieldName]?.status) && (
            <Box sx={{ ml: 2, mt: 0.5, width: "98%" }}>
              <InputField
                placeholder={"Enter Text"}
                fieldName={el?.fieldName}
                value={
                  el?.fieldName === "operatingStandards"
                    ? formData?.[el.fieldName]
                    : formData?.[el.fieldName]?.remark
                }
                handleChange={handleChange}
                mt="-5px"
                disabled={disabled}
              />
              <p
                color="error"
                variant="caption"
                style={{
                  lineHeight: "1.2",
                  margin: "2px 0",
                  marginTop: "5px",
                  color: "#d34040",
                  fontSize: "10px",
                  fontStyle: "italic",
                }}
              >
                {errors[el?.fieldName]}
              </p>
            </Box>
          )}
        </Box>
      ))}
    </>
  );

  return (
    <>
      {!hide ? (
        <MainDashboardLayout sidebar={<GRISidebar />}>
          {renderContent({ hide })}

          <>
            {!griReview ? (
              <Box sx={{ ml: "1rem", width: "98%" }}>
                <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
              </Box>
            ) : (
              <Box textAlign="right" sx={{ mt: 3 }}>
                <Button
                  onClick={handleSubmit}
                  variant="contained"
                  sx={{
                    bgcolor: "#1C486B",
                    textTransform: "none",
                    mt: 3,
                    mb: 5,
                  }}
                >
                  Save & Continue <EastIcon sx={{ ml: 2 }} />
                </Button>
              </Box>
            )}
          </>
        </MainDashboardLayout>
      ) : (
        renderContent({ hide })
      )}
    </>
  );
};

export default GRI303_2;
